import React from 'react';
import Form from './Form';
import Tasks from './Tasks';

const Main = () => {
    return (
        <div>
            <h1> NOTEPAD </h1>
            <Form />
            <Tasks />
        </div >
    )
}
export default Main;